function orderProgress() {
  let progress = $('#order-progress').data('progress');
  $('.order__progress').css('height', progress + '%');
}
